module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-11.008896d6.png";